var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170,700L57.5,840.6c-4.7,5.9-11.9,9.4-19.5,9.4H0l50-250L0,350h38c7.6,0,14.8,3.5,19.5,9.4L170,500h280 L356,29.9c-2.7-13.5,6.1-26.7,19.6-29.4c1.6-0.3,3.3-0.5,4.9-0.5H400c31,0,59.8,16.3,75.7,42.9L750,500h289 c40.6,0,80.3,12.4,113.8,35.5l21,14.5c27.6,19.1,34.5,57,15.4,84.6c-4.2,6-9.4,11.3-15.4,15.4l-21,14.5 c-33.4,23.1-73.1,35.5-113.8,35.5H750l-274.3,457.1c-16,26.6-44.7,42.9-75.7,42.9h-19.5c-1.6,0-3.3-0.2-4.9-0.5 c-13.5-2.7-22.3-15.9-19.6-29.4L450,700L170,700z M600,200h100c27.6,0,50,22.4,50,50v50c0,27.6-22.4,50-50,50L600,200z M615.1,1000 l100-150c27.6,0,50,22.4,50,50v50c0,27.6-22.4,50-50,50H615.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/Plane.77881c3a4da780ab425aeb8e8e9c7a54.svg";
export { ForwardRef as ReactComponent };